import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { Task, Ticket } from "../../../services/swagger";
import { useState } from "react";
import CreateTaskDialog from "./CreateTaskDialog";
import TicketTaskDialog from "../TaskDialog";
import { useTranslation } from "react-i18next";
import FieldLabel from "../../atoms/FieldLabel";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddIcon from "@mui/icons-material/Add";

export interface TicketTasksProps {
  ticket: Ticket;
}

export interface TicketTaskProps {
  task: Task;
  ticket: Ticket;
}

function TicketTask(props: TicketTaskProps) {
  const { t } = useTranslation("Ticket");
  const { task, ticket } = props;
  const [open, setOpen] = useState(false);
  let severity: "info" | "error" | "success" | "warning" = "info";
  if (task.cancelDate) severity = "error";
  else if (task.endDate) severity = "success";
  else if (task.startDate) severity = "warning";
  return (
    <>
      <TicketTaskDialog
        open={open}
        ticket={ticket}
        task={task}
        onClose={() => setOpen(false)}
      />
      <Alert
        severity={severity}
        action={
          <Button
            color="inherit"
            variant="outlined"
            size="small"
            onClick={() => setOpen(true)}
          >
            {t("View")}
          </Button>
        }
      >
        {task.title}
      </Alert>
    </>
  );
}

export default function TicketTasks(props: TicketTasksProps) {
  const { t } = useTranslation("Ticket");
  const { ticket } = props;
  const [createDialog, setCreateDialog] = useState(false);

  const handleClickCreateTask = () => {
    setCreateDialog(true);
  };

  const handleCloseCreateTask = () => {
    setCreateDialog(false);
  };

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: (theme) => (theme.shape.borderRadius as number) / 8,
      }}
    >
      <CreateTaskDialog
        open={createDialog}
        ticketId={ticket._id}
        onClose={handleCloseCreateTask}
      />
      <Stack spacing={2}>
        <Box>
          <Button
            onClick={handleClickCreateTask}
            variant="text"
            sx={{
              textTransform: "none",
              position: "relative",
              p: 1,
              boxSizing: "content-box",
              m: "-8px !important",
            }}
            fullWidth
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <AssignmentIcon fontSize="small" color="primary" />
                <FieldLabel>{t("Tasks")}</FieldLabel>
              </Stack>

              {(ticket.status === "Not reviewed" ||
                ticket.status === "Incomplete") && (
                <>
                  <AddIcon fontSize={"small"} sx={{ color: "grey" }} />
                </>
              )}
            </Stack>
          </Button>
        </Box>

        {ticket.tasks.length > 0 ? (
          ticket.tasks.map((e) => {
            return <TicketTask key={e._id} ticket={ticket} task={e} />;
          })
        ) : (
          <Typography color="text.secondary">{t("NoTasks")}</Typography>
        )}
      </Stack>
    </Box>
  );
}
